<template>
  <v-layout justify-center>
    <div>
      <v-layout>
        <v-flex xm12 md4 offset-md4 class="text-sm-center">
          <span class="headline">LIST</span><br />
        </v-flex>
        <v-flex xm12 sm4 class="title text-sm-right">
          <v-btn fab outline small value="download" color="primary" @click="onExport()">
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn fab outline small value="email" color="primary" @click="buildEmail()" :disabled="!selected">
            <v-icon>email</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <vue-good-table
          ref="my-table"
          styleClass="vgt-table striped bordered"
          :max-height=this.height
          :fixed-header="true"
          :columns="columns"
          :isLoading=this.isTableLoading
          :rows="rows"
          @on-cell-click="onCellClick"
          :select-options="{
            enabled: true,
            selectOnCheckboxOnly: true
          }"
          :search-options="{
            enabled: true
          }">
          <template slot="loadingContent">
            <div>
              <v-progress-circular
                :size="50"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
          <div slot="table-actions-bottom">
            <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'actions'">
              <div class="text-xs-center">
                <v-avatar
                  color="blue lighten-4"
                  class="mr-2 mt-2"
                  size="30"
                  style="cursor: pointer;"
                  @click="editItem(props)"
                >
                  <v-icon small>edit</v-icon>
                </v-avatar>
              </div>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </v-flex>

      <v-btn
        fab
        bottom
        right
        color="blue"
        dark
        fixed
        class="add-button-bottom"
        @click="addSponsor"
      >
        <v-icon>add</v-icon>
      </v-btn>

      <EmailForm
        :visible="showEmailForm"
        :items="emailList"
        :selectedItems="emails"
        :emailTemplates="emailTemplates"
        :emailTemplateId="0"
        :rows="varList"
        section="Sponsor"
        persistent
        @close="closeThis"
      />

      <InternalForm
        :visible="showEvalForm"
        :item="evalItem"
        :key="evalItem.id"
        :memberList="memberList"
        :currentYear="currentYear"
        persistent
        @close="closeThisEval"
      />

      <v-dialog v-model="dialog" max-width="1000px" persistent>
        <v-card >
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add Sponsor</v-toolbar-title>
          </v-toolbar>

          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.name"
                      label="Company"
                      ref="focusName"
                      :rules="[v => !!v || 'Company is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.address"
                      label="Address"
                      :rules="[v => !!v || 'Address is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.city"
                          label="City"
                          :rules="[v => !!v || 'City is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.state"
                          label="State"
                          :rules="[v => !!v || 'State is required']"
                          mask="AA"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.phone"
                          label="Phone"
                          :rules="[v => !!v || 'Phone is required']"
                          required
                          return-masked-value
                          mask="(###) ###-####"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.zip"
                          label="Postal Code"
                          :rules="[v => !!v || 'Postal Code is required']"
                          required
                          mask="#####"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.webSite"
                      label="Website"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="editedItem.notes"
                      label="Notes"
                      prepend-icon="notes"
                    ></v-textarea>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PRIMARY CONTACT</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.firstName"
                      @keyup.enter="save"
                      label="First Name"
                      :rules="[v => !!v || 'First Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.lastName"
                      @keyup.enter="save"
                      label="Last Name"
                      :rules="[v => !!v || 'Last Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="editedItem.contactPhone"
                      label="Phone"
                      prepend-icon="phone"
                      :rules="[v => !!v || 'Phone is required']"
                      required
                      mask="(###) ###-####"
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-text-field
                      v-model="editedItem.title"
                      label="Title"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="editedItem.mobile"
                      label="Mobile"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-text-field
                      prepend-icon="email"
                      label="Email"
                      type="email"
                      v-model="editedItem.email"
                      :rules="emailRules"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save">Save</v-btn>
          </v-card-actions>
        </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="viewDialog" max-width="500px">
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-flex xs12 class="text-xs-center text-sm-center">
                    <span class="headline">{{ editedItem.name }}</span><br />
                    <span class="subheading">Booth(s): {{ editedItem.title }}</span><br />
                    {{ editedItem.address }}<br />
                    {{ editedItem.city }}, {{ editedItem.state }} {{ editedItem.zip }}
                  </v-flex>
                  <v-flex xs12>
                    <v-btn
                      v-if="editedItem.email"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="sendEmail"
                    >
                      Email {{editedItem.firstName}}
                      <v-icon right dark>email</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="editedItem.cellPhone"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="callMobile"
                    >
                      Call Primary
                      <v-icon right dark>mobile_screen_share</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="editedItem.homePhone"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="callHome"
                    >
                      Call Primary Onsite
                      <v-icon right dark>mobile_screen_share</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="editedItem.workPhone"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="callWork"
                    >
                      Call Secondary Onsite
                      <v-icon right dark>mobile_screen_share</v-icon>
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </div>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import VLazyImage from 'v-lazy-image'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import EmailForm from '../forms/EmailTempForm'
import InternalForm from './InternalForm.vue'
import XLSX from 'xlsx'

export default {
  props: ['visible', 'currentYear'],

  components: {
    VueGoodTable,
    VLazyImage,
    EmailForm,
    InternalForm
  },
  data () {
    return {
      valid: true,
      myId: this.$store.state.user.id,
      myName: this.$store.state.user.fullName,
      myEmail: this.$store.state.user.email,
      page: 'Sponsor List',
      searchSelect: [],
      searchType: '',
      isAdmin: this.$store.state.isAdmin,
      isCommChair: false,
      dialog: false,
      error: '',
      viewDialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Company Name',
          field: 'name',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Name',
          field: 'contact.fullName',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Phone',
          field: 'contact.phone',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Email',
          field: 'contact.email',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Level',
          field: 'detailName',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Expires',
          field: 'detailYear',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Edit',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      committeeHeader: {},
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      callMobile: '',
      newRows: [],
      rows: [],
      printRows: [],
      editedItem: {},
      evalItem: {},
      showEmailForm: false,
      showEvalForm: false,
      emails: [],
      cc: [],
      bcc: [],
      emailList: [],
      varList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      memberList: [],
      emailTemplates: [],
      yesNo: ['Yes', 'No']
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear
    this.searchType = this.$store.state.currentYear
    this.yearList()

    this.isTableLoading = true

    if (this.$route.params.currentYear) {
      this.currentYear = this.$route.params.currentYear
    } else {
      this.currentYear = this.$store.state.currentYear
    }

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getMembers()
    this.getSponsors()
    this.getEmailTemplates()

    this.loading = false
    console.log('Chair', this.isCommChair)

    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    currentYear: {
      handler: function (val, oldVal) {
        this.getSponsors()
      },
      deep: true
    }
  },

  methods: {
    yearList () {
      for (let i = this.$store.state.currentYear; i >= 2022; i--) {
        this.searchSelect.push(i)
      }
    },

    handleResize () {
      const height = window.innerHeight - 360
      this.height = height + 'px'
    },

    async getMembers () {
      try {
        const response = await Api().get('get_committee_by_code/SPC/' + this.currentYear)
        this.memberList = response.data.committee.Users
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    addSponsor () {
      this.dialog = true
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear
        this.editedItem.UserId = this.myId

        if (this.$refs.form.validate()) {
          const response = await Api().post('sponsors', this.editedItem)

          this.getSponsors()
          this.editedItem = {}
          this.showEvalForm = false

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    editItem (props) {
      this.evalItem = props.row

      this.showEvalForm = true
    },

    async onCellClick (params) {
      try {
        console.log('props', params.row)
        console.log('props', params.row.SponsorDetails[0].primaryContact)
        if (params.column.field === 'name') {
          this.editedItem.id = params.row.id
          this.editedItem.name = params.row.name
          this.editedItem.address = params.row.address
          this.editedItem.city = params.row.city
          this.editedItem.state = params.row.state
          this.editedItem.zip = params.row.zip

          const response = await Api().get('sponsor_contact/' + params.row.SponsorDetails[0].primaryContact)
          const contact = response.data
          if (contact) {
            this.editedItem.cellPhone = contact.mobile
            this.callMobile = 'tel:' + contact.mobile
          }

          const response1 = await Api().get('sponsor_contact/' + params.row.SponsorDetails[0].primaryOnsite)
          const contact1 = response1.data
          if (contact1) {
            this.editedItem.homePhone = contact1.mobile
            this.homePhone = 'tel:' + contact1.mobile
          }

          const response2 = await Api().get('sponsor_contact/' + params.row.SponsorDetails[0].secondaryOnsite)
          const contact2 = response2.data
          if (contact2) {
            this.editedItem.workPhone = contact2.mobile
            this.workPhone = 'tel:' + contact2.mobile
          }

          this.viewDialog = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getEmailTemplates () {
      try {
        const response = await Api().get('get_email_templates/Sponsor')
        this.emailTemplates = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getSponsors () {
      try {
        const response = await Api().get('sponsors/')

        const sponsorList = response.data
        console.log(sponsorList)

        for (let i in sponsorList) {
          let contact = sponsorList[i].SponsorContacts[0]
          sponsorList[i].contact = contact
          sponsorList[i].contactName = sponsorList[i].SponsorContacts[0].firstName + ' ' + sponsorList[i].SponsorContacts[0].lastName
          sponsorList[i].email = sponsorList[i].SponsorContacts[0].email

          for (let j in sponsorList[i].SponsorDetails) {
            if (sponsorList[i].SponsorDetails[j].active === 'Yes') {
              sponsorList[i].detailName = sponsorList[i].SponsorDetails[j].name
              sponsorList[i].detailYear = sponsorList[i].SponsorDetails[j].year
            }
          }
        }

        this.rows = sponsorList

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    searchYear () {
      this.currentYear = this.searchType
      this.getSponsors()
    },

    buildEmail () {
      let vars = {}
      for (let i in this.rows) {
        this.emailList[i] = this.rows[i].SponsorContacts[0].email
        vars.company = this.rows[i].name
        vars.password = this.rows[i].password
        vars.email = this.rows[i].SponsorContacts[0].email
        vars.firstName = this.rows[i].SponsorContacts[0].firstName
        vars.lastName = this.rows[i].SponsorContacts[0].lastName

        this.varList[i] = vars
        vars = {}
      }

      for (let i in this.$refs['my-table'].selectedRows) {
        this.emails[i] = this.$refs['my-table'].selectedRows[i].SponsorContacts[0].email
      }

      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    async onExport () {
      try {
        await Api().get('sponsors')
          .then(res => {
            const sponsorList = res.data
            console.log('NEW', sponsorList)

            let row = {}
            for (let i in sponsorList) {
              row.name = sponsorList[i].name
              row.address = sponsorList[i].address
              row.city = sponsorList[i].city
              row.state = sponsorList[i].state
              row.zip = sponsorList[i].zip
              row.fullName = sponsorList[i].SponsorContacts[0].fullName
              row.email = sponsorList[i].SponsorContacts[0].email
              row.phone = sponsorList[i].SponsorContacts[0].phone

              let rep = ''
              if (sponsorList[i].SponsorDetails.length > 0) {
                row.levelName = sponsorList[i].SponsorDetails[0].name

                if (sponsorList[i].SponsorDetails[0].User) {
                  let user = sponsorList[i].SponsorDetails[0].User
                  rep = user.fullName
                }

                if (sponsorList[i].SponsorDetails[0].SponsorLevels.length > 0) {
                  const levels = sponsorList[i].SponsorDetails[0].SponsorLevels
                  let totprice = 0
                  let tottrade = 0

                  for (let j in levels) {
                    let price = Number(levels[j].price)
                    let trade = Number(levels[j].trade)

                    totprice += price
                    tottrade += trade
                  }
                  row.price = totprice
                  row.trade = tottrade
                }
              } else {
                row.levelName = ''
              }

              row.rep = rep

              this.printRows.push(row)
              row = {}
            }

            let printSponsors = this.printRows.map(a => ({
              'Name': a.name,
              'Address': a.address,
              'City': a.city,
              'State': a.state,
              'Zip': a.zip,
              'Contact': a.fullName,
              'Email': a.email,
              'Phone': a.phone,
              'Level': a.levelName,
              'Rep': a.rep,
              'Total Cash': a.price,
              'TotalTrade': a.trade
            }))
            console.log(printSponsors)

            let membersWS = XLSX.utils.json_to_sheet(printSponsors)

            let wb = XLSX.utils.book_new()

            if (!wb.Props) { wb.Props = {} }
            wb.Props.Title = 'Vendor_list'

            XLSX.utils.book_append_sheet(wb, membersWS, 'Vendor_list')

            XLSX.writeFile(wb, 'Vendor_list.xlsx')
          })
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    remove (item) {
      this.emails.splice(this.emails.indexOf(item), 1)
      this.emails = [...this.emails]
    },

    closeThis (item) {
      this.emails = []
      this.showEmailForm = false
    },

    closeThisEval (item) {
      this.evalItem = {}
      this.showEvalForm = false
    },

    close () {
      this.initialImage = null
      this.dialog = false
      this.viewDialog = false
      this.showEmailForm = false
      this.showEvalForm = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/sponsor/List.vue